import type { Tool } from "@app-types/activity-data.types";

export const toolDetails: Record<
  Tool,
  { label: string; description: string; letter: string; colour: string }
> = {
  "miro-ai": {
    label: "Miro - Whiteboarding, maps, and virtual brainstorms",
    description:
      "Perfect for mapping customer touchpoints, layout sketches, and information architectures.",
    letter: "M",
    colour: "#ffd02f",
  },
  "figma-ai": {
    label: "Figma - UI layout, prototyping, and design systems",
    description:
      "Ideal for refining digital components, asset packaging, and layout fidelity.",
    letter: "F",
    colour: "#f24e1e",
  },
  atlassian: {
    label:
      "Atlassian Jira/Confluence - Documentation, task management, and sprints",
    description:
      "Synthesise requirements, plan developmental blocks, and structure specifications.",
    letter: "A",
    colour: "#1868db",
  },
  coco: {
    label: "Coco - Data analysis, modelling, and insight extraction",
    description:
      "Query large datasets, build analytical data models, and extract business insights.",
    letter: "C",
    colour: "#196347",
  },
  gemini: {
    label: "Gemini - Research, analysis, and content generation",
    description:
      "Explore ideas, synthesise information, and create useful first drafts.",
    letter: "G",
    colour: "#4285f4",
  },
  genie: {
    label: "Genie - Data exploration and conversational analytics",
    description:
      "Ask questions of your data and turn findings into practical insights.",
    letter: "G",
    colour: "#7c3aed",
  },
  sigma: {
    label: "Sigma - Collaborative analytics and data visualisation",
    description: "Build clear analyses, dashboards, and data-led narratives.",
    letter: "S",
    colour: "#37bea7",
  },
};
